import * as React from "react";
import { Component } from "react";
import MenuButton from "react-md/lib/Menus/MenuButton";
import { Link } from "react-router-dom";

import routesInfo from "../../../config/routesInfo";
import ListItem from "react-md/lib/Lists/ListItem";

class TopNav extends Component {
  private getMenuItems(route: IRoutesInfo, pathPrefix: string) {
    return route.childRoutes.map(r => (
      <Link key={r.title} to={"/" + pathPrefix + "/" + r.pathName}>
        <ListItem key={r.title} primaryText={r.title} />
      </Link>
    ));
  }

  private renderMenus() {
    return routesInfo.map(r => (
      <MenuButton
        id={r.pathName}
        key={r.title}
        raised
        primary
        menuItems={this.getMenuItems(r, r.pathName)}
        simplifiedMenu={false}
      >
        {r.title}
      </MenuButton>
    ));
  }

  render() {
    return <nav className="HeaderNav">{this.renderMenus()}</nav>;
  }
}

export default TopNav;



// WEBPACK FOOTER //
// ./src/components/layout/header/TopNav.tsx